// Logo path (public asset)
export const NAVBAR_LOGO = `${process.env.PUBLIC_URL}/assets/logo/transparent.png`;

// Company Name
export const COMPANY_NAME = 'Safinah Al Sama Shipping LLC';

// Section IDs used for scrolling
export const NAV_SECTIONS = {
  hero: 'hero-container',
  about: 'about-section-container',
  services: 'service-container',
  contact: 'contact-container',
};

// Navigation Items
export const NAV_ITEMS = [
  { label: 'About', id: NAV_SECTIONS.about },
  { label: 'Services', id: NAV_SECTIONS.services },
  { label: 'Contact', id: NAV_SECTIONS.contact },
];

// Logo Styles (optional centralization)
export const LOGO_IMAGE_PROPS = {
  width: 48,
  height: 48,
  mr: 1.5,
  objectFit: 'contain',
  padding: 0.5,
  bgcolor: 'transparent',
  borderRadius: '50%',
  position: 'relative',
  overflow: 'hidden',
};
